import { useState } from "react";
import GradientBlue from "../../../Components/InputFields/GradientBlue";
import LogoWhite10 from "../../../Media/PNG/LogoWhite10.svg";
import LogoBlue from "../../../Media/PNG/LogoBlue.svg";
import Back from "./Back";
import OtpCode from "../../../Components/InputFields/OtpCode";

export default function ContainerForgotPWCode({ email, onBack, onContinue }) {
  const logoSrc = document.documentElement.classList.contains("dark")
    ? LogoWhite10
    : LogoBlue;
  const [inputNums, setInputNums] = useState(["", "", "", "", "", ""]);
  const [codeInvalid, setCodeInvalid] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    const verificationCode = inputNums.join("");
    if (verificationCode.length !== 6) {
      setCodeInvalid(true);
      return;
    }
    onContinue(verificationCode);
  };

  return (
    <div className="w-full max-w-sm bg-zi-bg2-light dark:bg-zi-inputbg-dark/50 rounded-3xl p-5 gap-7 flex flex-col">
      <div className="flex flex-col gap-2 justify-center items-center">
        <div className="h-14">
          <img src={logoSrc} alt="لوگو" className="w-14" />
        </div>
        <p className="font-medium text-sm text-zi-text-light dark:text-zi-text-dark">
          کوژیتو فاند
        </p>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex justify-between items-center">
          <h1 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
            کد یک‌بار مصرف را وارد کنید
          </h1>
          <Back onClick={onBack} />
        </div>
        <span className="text-xs font-light text-zi-text-light/50 dark:text-zi-text-dark/50">
          کدی که به ایمیل {email} ارسال شده را وارد کنید.
        </span>
      </div>
      <form className="flex flex-col gap-7" onSubmit={handleSubmit}>
        <div className="flex flex-col gap-4 items-end">
          <OtpCode
            values={inputNums}
            setValues={setInputNums}
            onValueChange={() => setCodeInvalid(false)}
            inputClassName="size-full aspect-square rounded-lg caret-zi-blue-light border border-zi-border-light dark:border-none bg-zi-bg2-light dark:bg-zi-inputbg-dark hocus-within:bg-zi-bg1-light text-center text-xl font-medium text-zi-text-light dark:text-zi-text-dark outline-none hocus-within:ring-1 hocus-within:ring-zi-border-light hocus-within:dark:ring-zi-border-dark [direction:ltr]"
          />
          <button
            type="button"
            className="text-zi-blue-light text-xs hocus:underline flex items-center gap-1"
          >
            <span>ارسال مجدد کد</span>
            <span>
              (<span>۶۰</span> ثانیه)
            </span>
          </button>
        </div>
        {codeInvalid && (
          <p className="text-amber-400 text-sm">لطفا کد شش رقمی را وارد کنید</p>
        )}
        <GradientBlue type="submit" value="ثبت" />
      </form>
    </div>
  );
}
